<template>
  <div
    class="button-container button-group-container"
    :class="{
      'button-group-row-container': row,
      'button-group-column-container': !row,
    }"
    :style="{ width: !row ? '40px' : null, height: row ? '40px' : null }"
  >
    <v-sheet class="d-flex" :class="{ 'flex-column': !row }" elevation="2">
      <v-btn
        v-for="(item, i) in items"
        :key="i + '' + item.titl"
        elevation="0"
        :height="size"
        text
        tile
        :title="item.title"
        :width="size"
        x-small
        @click="item.onClick"
      >
        <v-icon>
          {{ item.icon }}
        </v-icon>
      </v-btn>
      <slot />
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    // {title:string,icon:string,onClick:(e)=>{}}
    items: {
      type: Array,
      default: () => [],
    },
    row: Boolean,
    size: { type: Number, default: 40 },
  },
  provide() {
    return {
      isGroup: true,
      size: this.size,
    }
  },
}
</script>

<style scoped>
/* .button-group-row-container >>> .v-btn:not(:last-child) {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.button-group-column-container >>> .v-btn:not(:first-child) {
  border-top: thin solid rgba(0, 0, 0, 0.12);
} */
</style>
